import { gql } from '@apollo/client';
import { IMeetingPlaceSeoDescription } from '../../interfaces/meetingPlaceSeoDescription';
import { IMeetingPlacePageEventItem } from './meetingPlacePageEventItem';
import { TTenantTypes } from './meetingPlacePageTenantList';

export interface IMeetingPlacePageEventList {
  slug: string;
  name: string;
  node_locale: string;
  customizedSlug: string;
  seoDescription: IMeetingPlaceSeoDescription;
  eventItemsCollection: {
    items: IMeetingPlacePageEventItem[];
  };
  tenant: TTenantTypes;
}

export const MeetingPlacePageEventListFragment = gql`
  fragment MeetingPlacePageEventList on MeetingPlacePageEventList {
    slug
    name
    seoDescription
    sys {
      id
      locale
    }
  }
`;
